import * as _ from 'lodash';

import { finleyAssert } from '@finley-technologies/common';

import {
  GetInstitutionAndConnectionDetailsForBorrowerIdQueryGQLType,
  Maybe,
} from '../../../../../types/dashboard-core-gqlTypes.generated.d';

export type BankAccountFormFields = {
  accountholder: string;
  financialInstitution: string;
  connectionProvider: string;
  accountName: string;
  routingNumber: string;
  accountNumber: string;
};

type InstitutionAndConnectionDetailsForBorrower = GetInstitutionAndConnectionDetailsForBorrowerIdQueryGQLType['institutionAndConnectionDetailsForBorrower'];

export const initialBankAccountValues: BankAccountFormFields = {
  accountholder: '',
  financialInstitution: '',
  connectionProvider: '',
  accountName: '',
  routingNumber: '',
  accountNumber: '',
};

export type ConnectionProviderConfig = Record<
  string,
  {
    bankInstitutionId: string;
    connectionProvider: 'plaid';
    connectionItemId: string;
    connectionAccountId: string;
    connectionAccountName: string;
    connectionSelectOptionName: string;
  }
>;

export const getFormattedBankAccountDefaultValues = ({
  organizationId,
  bankInstitutionId,
  accountName,
  routingNumber,
  accountNumber,
  plaidAccountId,
}: {
  organizationId: string;
  bankInstitutionId: string;
  accountName: string;
  routingNumber: string;
  accountNumber: string;
  plaidAccountId?: Maybe<string>;
}): BankAccountFormFields => {
  let formattedConnectionProvider: string;
  if (plaidAccountId) {
    formattedConnectionProvider = `plaid_${plaidAccountId}`;
  } else {
    formattedConnectionProvider = 'None';
  }

  return {
    accountholder: organizationId,
    financialInstitution: bankInstitutionId,
    connectionProvider: formattedConnectionProvider,
    accountName,
    routingNumber,
    accountNumber,
  };
};

export const getConnectionProviderConfig = ({
  institutionAndConnectionDetails,
}: {
  institutionAndConnectionDetails: InstitutionAndConnectionDetailsForBorrower;
}) => {
  const connectionProviderConfig: ConnectionProviderConfig = {};

  _.forEach(
    institutionAndConnectionDetails,
    (institutionAndConnectionDetail) => {
      const {
        plaidBankInstitutionId,
        plaidBankInstitutionName,
        plaidItemId,
        plaidAccountId,
        plaidAccountMask,
        plaidAccountName,
      } = institutionAndConnectionDetail;
      if (plaidAccountId && plaidItemId) {
        finleyAssert(
          plaidAccountName && plaidBankInstitutionId,
          'plaidAccountName and bankInstitutionName must exist for a given plaidAccountId',
        );

        const plaidAccountString = `Plaid - ${plaidBankInstitutionName} ${plaidAccountName} (${plaidAccountMask})`;

        const connectionProviderConfigKey = `plaid_${plaidAccountId}`;

        connectionProviderConfig[connectionProviderConfigKey] = {
          bankInstitutionId: plaidBankInstitutionId,
          connectionProvider: 'plaid',
          connectionItemId: plaidItemId,
          connectionAccountId: plaidAccountId,
          connectionAccountName: plaidAccountName,
          connectionSelectOptionName: plaidAccountString,
        };
      }
    },
  );
  return connectionProviderConfig;
};
